import React from 'react';
import cn from 'clsx';
import { LinkWithGAClickButton, Typography } from 'common/components';
import {
  downloadExampleButton,
  downloadExampleIcon,
  downloadExampleLabel,
} from './download-example-link-styles';

type DownloadExampleLinkProps = {
  className?: string;
  elementBlock: string;
  elementText: string;
  href: string;
  label: string;
  src: string;
};

/**
 * Вью компонента загрузки примеров проектных услуг
 */
export const DownloadExampleLink: React.FC<DownloadExampleLinkProps> = ({
  className,
  elementBlock,
  elementText,
  href,
  label,
  src,
}) => (
  <LinkWithGAClickButton
    className={cn(downloadExampleButton, className)}
    elementBlock={elementBlock}
    elementText={label}
    elementName={elementText}
    href={href}
    title={label}
    rel="noreferrer"
    target="_blank">
    <img alt={label} className={downloadExampleIcon} src={src} title={label} itemProp="image" />
    <Typography className={downloadExampleLabel} variant="m" size="body_short">
      {label}
    </Typography>
  </LinkWithGAClickButton>
);
